import useStyles from './PartnerDocumentItem.styles';
import { PartnerDocument } from 'types/Partner';
import { FilePreview } from 'components';

type PartnerDocumentItemProps = {
  document: PartnerDocument;
};

const PartnerDocumentItem = ({
  document,
}: PartnerDocumentItemProps): JSX.Element => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <FilePreview document={document} useBlobForExtension />
      <div className={classes.title}>{document.name}</div>
    </div>
  );
};

export default PartnerDocumentItem;
